import * as types from '../mutation-types'
import moment from 'moment';
export default {
	namespaced: true,

	state: {
		vacations: [],
		vacationsDayDetails: []
	},

	actions: {
		fetchAll({ commit }) {
			return window.axios.get('/vacation').then(({ data }) => {
				const vacationInfo = data
				const disabledDates = []
				for (let i = 0; i < vacationInfo.length; i++) {
					const fromDate = moment(moment(vacationInfo[i].fromDate).format('YYYY-MM-DD'));
					const toDate = moment(moment(vacationInfo[i].toDate).format('YYYY-MM-DD'));
        
					for (let date = fromDate; date.isBefore(toDate) || date.isSame(toDate); date.add(1, 'days')) {
						disabledDates.push(date.format('YYYY-MM-DD'));
					}
				}
				commit(types.STORE_VACATION, vacationInfo)
      
				commit(types.STORE_VACATIONS_DAYS_DETAILS, disabledDates)
				return data;
			})
		}
	},

	mutations: {
		[types.STORE_VACATION](state, vacations) {
			state.vacations = vacations;
		},

		[types.STORE_VACATIONS_DAYS_DETAILS] (state, vacationsDayDetails) {
			state.vacationsDayDetails = vacationsDayDetails
		}
	}
}